import { forwardRef, InputHTMLAttributes } from 'react';

import { TextInput } from '../../inputs/TextInput/TextInput';
import { DefaultFormFieldLayout } from '../DefaultFormFieldLayout/DefaultFormFieldLayout';
import type { HelperText } from '../FormFieldHelperText/FormFieldHelperText';

export type CoreFormFieldNumberProps = {
  inputProps: InputHTMLAttributes<HTMLInputElement>;
  label?: React.ReactNode;
  error?: string;
  helperText?: HelperText;
  inline?: boolean;
};

export const CoreFormFieldNumber = forwardRef(function _CoreFormFieldNumber(
  { error, helperText, inline, inputProps, label }: CoreFormFieldNumberProps,
  ref: React.Ref<HTMLInputElement>
) {
  return (
    <DefaultFormFieldLayout
      label={label}
      error={error}
      inputId={inputProps.id}
      inline={inline}
      helperText={helperText}
    >
      <div className="relative flex items-center">
        <TextInput
          data-testid={inputProps.id}
          {...inputProps}
          error={error}
          ref={ref}
          type="number"
        />
      </div>
    </DefaultFormFieldLayout>
  );
});
